// hooks/useRouteAnnouncer.js
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useTranslation } from './useTranslation';

export function useRouteAnnouncer() {
  const location = useLocation();
  const { translations } = useTranslation();

  useEffect(() => {
    const announcer = document.getElementById('route-announcer');
    if (!announcer) return;

    // Small delay lets the new page render its title first
    const timer = setTimeout(() => {
      announcer.textContent = document.title || 'New page loaded';
      announcer.focus({ preventScroll: true });
    }, 100);

    return () => clearTimeout(timer);
  }, [location.pathname, translations]);
}